import { render, staticRenderFns } from "./AppointmentDefaultsSet.vue?vue&type=template&id=5b66fc98"
import script from "./AppointmentDefaultsSet.vue?vue&type=script&lang=js"
export * from "./AppointmentDefaultsSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports